import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { IUserInfoState, setUserBalance } from ".";
import { IBalanceOper } from "../debug";
import { now } from "../../utils/time";
import { exportBalanceOperation } from "../debug/export-balance-operations.handler";

export const setUserBalanceAndLog = createAsyncThunk(
    'userInfo/setUserBalanceAndLog',
    async (balance: number, { dispatch }) => {
        dispatch(setUserBalance({ balance }));
  
        const balanceOperation: IBalanceOper = {
            balance,
            operdate: now(),
        };

        dispatch(exportBalanceOperation(balanceOperation))
    }
);

const setUserBalanceAndLogHandler = (builder: ActionReducerMapBuilder<IUserInfoState>) => {
    builder
        .addCase(setUserBalanceAndLog.fulfilled, (state: IUserInfoState) => {})
};

export default setUserBalanceAndLogHandler;